import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBztxtmKPwMo9GBQIchayPqpclhRyDYL7c",
  authDomain: "stimuli-central.firebaseapp.com",
  projectId: "stimuli-central",
  storageBucket: "stimuli-central-5fe9c.firebasestorage.app",
  messagingSenderId: "402114735257",
  appId: "1:402114735257:web:c795387c63a0edfaed1c08",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
